/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementItemEssential } from '../../models/asset-management-item-essential';
import { BaseResponse } from '../../models/base-response';

export interface WarehouseControllerIsAssetManagementMovable$Params {
  am_id: number;
  check_related_delivery?: boolean;
  check_related_warehouse?: boolean;
  check_related_ddt?: boolean;
  check_registry_end_customer_contact?: boolean;
}

export function warehouseControllerIsAssetManagementMovable(http: HttpClient, rootUrl: string, params: WarehouseControllerIsAssetManagementMovable$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItemEssential;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerIsAssetManagementMovable.PATH, 'get');
  if (params) {
    rb.query('am_id', params.am_id, {});
    rb.query('check_related_delivery', params.check_related_delivery, {});
    rb.query('check_related_warehouse', params.check_related_warehouse, {});
    rb.query('check_related_ddt', params.check_related_ddt, {});
    rb.query('check_registry_end_customer_contact', params.check_registry_end_customer_contact, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementItemEssential;
      }>;
    })
  );
}

warehouseControllerIsAssetManagementMovable.PATH = '/warehouse/isAssetManagementMovable';
